import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation JSON files
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import pt from "./locales/pt.json";

i18n
  .use(LanguageDetector)       // Detect user language
  .use(initReactI18next)       // Bind react-i18next to i18n
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      zh: { translation: zh },
      ja: { translation: ja },
      pt: { translation: pt },
    },

    fallbackLng: "en",         // Default if language not found
    supportedLngs: ["en", "fr", "es", "pt", "zh", "ja"],
    // "pt-BR" from the browser → "pt" (Brazilian Portuguese)
    nonExplicitSupportedLngs: true,

    detection: {
      // Order in which the detector checks languages
      order: ["querystring", "localStorage", "navigator", "htmlTag", "path", "subdomain"],

      // Where to store user-selected language
      caches: ["localStorage"],
    },

    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
